(() => {
  if (window.NeuStudentsDirectoryLoaded) return;
  window.NeuStudentsDirectoryLoaded = true;

  const ready = (callback) => {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', callback, { once: true });
    else callback();
  };

  const normalize = (value = '') => value
    .toString()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim()
    .toLowerCase();

  ready(() => {
    const landingMarker = document.querySelector('[data-students-landing]');
    if (!landingMarker) return;
    const root = document;
    const personSingular = landingMarker.dataset.personSingular || 'alumna certificada';
    const personPlural = landingMarker.dataset.personPlural || 'alumnas certificadas';

    const cards = [...root.querySelectorAll('[data-student-card]')];
    const featuredCards = [...root.querySelectorAll('[data-featured-student]')];
    const searchForms = [...root.querySelectorAll('[data-student-search-form]')];
    const searchInputs = [...root.querySelectorAll('[data-student-search]')];
    const statusNodes = [...root.querySelectorAll('[data-student-search-status]')];
    const filterContainers = [...root.querySelectorAll('[data-student-filters]')];
    const state = { query: '', country: '' };

    const setFeaturedSlide = (slide) => {
      const carousel = slide && slide.closest('[data-student-carousel]');
      if (!carousel) return;
      const index = [...carousel.querySelectorAll('[data-featured-student]')].indexOf(slide);
      const dot = carousel.querySelector(`[data-carousel-dot="${index}"]`);
      if (dot) dot.click();
    };

    const updateStatus = (visibleCount) => {
      let message = `${visibleCount} ${visibleCount === 1 ? personSingular : personPlural}`;
      if (state.query) message = `${visibleCount} ${visibleCount === 1 ? 'resultado' : 'resultados'} para “${state.query}”`;
      if (state.country) {
        const active = [...root.querySelectorAll('[data-country-filter]')].find((button) => button.dataset.countryFilter === state.country);
        const label = active ? active.textContent.trim() : state.country;
        message += ` en ${label}`;
      }
      statusNodes.forEach((node) => { node.textContent = message; });
    };

    const applyFilters = ({ scroll = false } = {}) => {
      let visibleCount = 0;
      cards.forEach((card) => {
        const matchesQuery = !state.query || normalize(card.dataset.search).includes(normalize(state.query));
        const matchesCountry = !state.country || normalize(card.dataset.country) === state.country;
        const visible = matchesQuery && matchesCountry;
        card.hidden = !visible;
        if (visible) visibleCount += 1;
      });

      root.querySelectorAll('[data-student-grid]').forEach((grid) => {
        const hasVisible = [...grid.querySelectorAll('[data-student-card]')].some((card) => !card.hidden);
        const empty = grid.querySelector('[data-student-empty]');
        if (empty) empty.hidden = hasVisible;
      });

      root.querySelectorAll('[data-country-filter]').forEach((button) => {
        const active = button.dataset.countryFilter === state.country;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      updateStatus(visibleCount);

      if (scroll) {
        const target = cards.find((card) => !card.hidden) || root.querySelector('[data-student-directory]');
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      return visibleCount;
    };

    const countries = [];
    cards.forEach((card) => {
      const label = (card.dataset.country || '').trim();
      if (label && !countries.some((entry) => normalize(entry) === normalize(label))) countries.push(label);
    });
    filterContainers.forEach((container) => {
      countries.forEach((country) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'students-filter';
        button.dataset.countryFilter = normalize(country);
        button.setAttribute('aria-pressed', 'false');
        button.textContent = country;
        container.appendChild(button);
      });
    });

    root.addEventListener('click', (event) => {
      const filter = event.target.closest('[data-country-filter]');
      if (!filter) return;
      state.country = filter.dataset.countryFilter || '';
      applyFilters({ scroll: true });
    });

    searchForms.forEach((form) => {
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        const input = form.querySelector('[data-student-search]');
        state.query = input ? input.value.trim() : '';
        state.country = '';
        searchInputs.forEach((otherInput) => { if (otherInput !== input) otherInput.value = state.query; });
        const featuredMatch = featuredCards.find((card) => normalize(card.dataset.search).includes(normalize(state.query)));
        if (featuredMatch && state.query) setFeaturedSlide(featuredMatch);
        applyFilters({ scroll: true });
      });
    });

    searchInputs.forEach((input) => {
      input.addEventListener('input', () => {
        if (input.value.trim()) return;
        state.query = '';
        applyFilters();
      });
    });

    root.querySelectorAll('[data-student-carousel]').forEach((carousel) => {
      const slides = [...carousel.querySelectorAll('[data-featured-student]')];
      const dots = [...carousel.querySelectorAll('[data-carousel-dot]')];
      if (!slides.length) return;
      let current = 0;
      let timer;
      const delay = Math.max(2000, Number(carousel.dataset.delay) || 4000);

      const show = (index) => {
        current = (index + slides.length) % slides.length;
        slides.forEach((slide, slideIndex) => {
          const active = slideIndex === current;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
        dots.forEach((dot, dotIndex) => {
          const active = dotIndex === current;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', active ? 'true' : 'false');
        });
      };
      const stop = () => window.clearInterval(timer);
      const start = () => {
        stop();
        if (slides.length > 1 && carousel.dataset.autoplay !== 'false') timer = window.setInterval(() => show(current + 1), delay);
      };
      dots.forEach((dot, index) => dot.addEventListener('click', () => { show(index); start(); }));
      carousel.addEventListener('mouseenter', stop);
      carousel.addEventListener('mouseleave', start);
      carousel.addEventListener('focusin', stop);
      carousel.addEventListener('focusout', start);
      show(0);
      start();
    });

    const popup = root.querySelector('[data-student-popup]');
    if (popup) {
      const storageKey = 'neubeauty-students-popup-seen';
      const delay = Math.max(0, Number(popup.dataset.delay) || 7000);
      let alreadySeen = false;
      try { alreadySeen = sessionStorage.getItem(storageKey) === 'true'; } catch (error) { alreadySeen = false; }
      const openPopup = () => {
        popup.hidden = false;
        window.requestAnimationFrame(() => popup.classList.add('is-open'));
        const close = popup.querySelector('[data-popup-close]');
        if (close) close.focus({ preventScroll: true });
        try { sessionStorage.setItem(storageKey, 'true'); } catch (error) { /* Storage can be blocked. */ }
      };
      const closePopup = () => {
        popup.classList.remove('is-open');
        window.setTimeout(() => { popup.hidden = true; }, 420);
      };
      popup.querySelectorAll('[data-popup-close]').forEach((button) => button.addEventListener('click', closePopup));
      popup.addEventListener('click', (event) => { if (event.target === popup) closePopup(); });
      document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && popup.classList.contains('is-open')) closePopup(); });
      if (!alreadySeen || (window.Shopify && window.Shopify.designMode)) window.setTimeout(openPopup, delay);
    }

    applyFilters();
  });
})();
